import { connect } from "react-redux";
import { ActionCableConsumer } from "react-actioncable-provider";
import PackGdn from "./PackGdn";
import { setTakePhotoModalKind, openSpeditorModal } from "actions/pack_gdn";

const PackGdnActionCable = (props) => {
  return (
    <ActionCableConsumer
      channel={{
        channel: "PackerChannel",
        gdn_id: props.match.params.id,
      }}
      onReceived={(res) => {
        switch (res.event) {
          case "close_photo_modal":
            if (res.kind == "over_pack_photo") {
              return;
            }
            props.setTakePhotoModalKind(null);
            if (res.kind === "photo") {
              props.openSpeditorModal(true);
            }
            break;
          default:
            break;
        }
      }}
    >
      <PackGdn {...props} />
    </ActionCableConsumer>
  );
};

export default connect(null, (dispatch) => ({
  setTakePhotoModalKind: (kind) => dispatch(setTakePhotoModalKind(kind)),
  openSpeditorModal: (is_open) => dispatch(openSpeditorModal(is_open)),
}))(PackGdnActionCable);
